import {
  OrderPartyChargeSearchRequest,
  OrderPartySearchRequest,
} from '@trukt/tms-api/OrderService';
import { createKey } from '../../createKey';

const keyHandler = createKey('order-party');

export const OrderPartyServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<OrderPartySearchRequest>(),
  searchCharges: keyHandler.createMethod<OrderPartyChargeSearchRequest>(),
};
